module.exports = __webpack_public_path__ + "img/xdyl.2541a543.png";